import * as React from 'react';

function SvgCart(props) {
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", fill: "none", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { fill: "currentColor", d: "M8.693 20.924a1.487 1.487 0 100-2.975 1.487 1.487 0 000 2.975zM19.106 20.924a1.487 1.487 0 100-2.975 1.487 1.487 0 000 2.975zM21.746 5.714a1.112 1.112 0 00-.863-.409H6.736L6.451 3.69a.744.744 0 00-.732-.615H2.744a.744.744 0 000 1.488h2.35L7.218 16.59a.744.744 0 00.733.614h11.9a.744.744 0 100-1.487H8.574l-.262-1.488h11.233a1.119 1.119 0 001.095-.896l1.338-6.694a1.115 1.115 0 00-.232-.926z" })));
}

export default SvgCart;
